module.exports = __webpack_public_path__ + "static/media/tumbleweed.90ac7381.png";